import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { metaCompraDimensaoApi } from '../api/metaCompraDimensao';
import type {
  AtualizarMetaCompraDimensaoRequest,
  CriarMetaCompraDimensaoRequest,
  DimensaoTipo,
  MetaCompraDimensaoFiltros,
} from '../types/metaCompraDimensao';

const KEY_LISTA = 'metaCompraDim-lista';
const KEY_OPCOES = 'metaCompraDim-opcoes';

const STALE_LISTA = 30 * 1000;
const STALE_OPCOES = 5 * 60 * 1000;

export function useMetasCompraDimensao(filtros: MetaCompraDimensaoFiltros) {
  return useQuery({
    queryKey: [KEY_LISTA, filtros],
    queryFn: () => metaCompraDimensaoApi.listar(filtros),
    enabled: !!filtros.anoMes,
    staleTime: STALE_LISTA,
  });
}

export function useOpcoesDimensao(dimensao: DimensaoTipo | null, query: string, enabled = true) {
  return useQuery({
    queryKey: [KEY_OPCOES, dimensao, query],
    queryFn: () => metaCompraDimensaoApi.opcoes(dimensao!, query),
    enabled: enabled && !!dimensao,
    staleTime: STALE_OPCOES,
  });
}

export function useCriarMetaCompraDimensao() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (req: CriarMetaCompraDimensaoRequest) => metaCompraDimensaoApi.criar(req),
    onSuccess: () => { qc.invalidateQueries({ queryKey: [KEY_LISTA] }); },
  });
}

export function useAtualizarMetaCompraDimensao() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (args: { id: number; req: AtualizarMetaCompraDimensaoRequest }) =>
      metaCompraDimensaoApi.atualizar(args.id, args.req),
    onSuccess: () => { qc.invalidateQueries({ queryKey: [KEY_LISTA] }); },
  });
}

export function useExcluirMetaCompraDimensao() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => metaCompraDimensaoApi.excluir(id),
    onSuccess: () => { qc.invalidateQueries({ queryKey: [KEY_LISTA] }); },
  });
}
